import * as React from 'react';
import cx from 'classnames';

import Button from 'components/ButtonDeprecated';
import ClipboardTrigger from 'components/ClipboardTrigger';
import Field from 'components/Field';
import Input from 'components/Input';
import Label from 'components/Label';
import ToastActions from 'actions/ToastActions';

import './styles/CopyToClipboardField.scss';

type Props = {
  label: string;
  value: string;
  theme?: 'whiteout' | 'gray';
};

const CopyToClipboardField = (props: Props) => {
  const { label, value, theme } = props;

  return (
    <Field className="CopyToClipboardField" flush>
      <Label>{label}</Label>
      <Input
        className={cx({
          'CopyToClipboardField--whiteout': theme === 'whiteout',
        })}
        value={value}
        disabled
        noBorder
        append={
          <ClipboardTrigger text={value} onCopy={() => ToastActions.showSuccessToast('Copied!')}>
            <Button level="text" color="mascot" weight="semibold">
              Copy
            </Button>
          </ClipboardTrigger>
        }
      />
    </Field>
  );
};

export default CopyToClipboardField;
